import {
  isTokenSuspicious,
  isTokenSuspiciousCheck,
  suspiciousCheckData,
  SuspiciousLabelAlert,
} from '../../Wallets/labels';
import { TokenIconWithChain } from 'modules/shared-components/asset/token-icon';
import { Chains } from 'api/types/httpsTypes/d-wallets';
import { EthAddress } from 'modules/ethereum/components/EthAddress';
import { ColumnsProps } from '../columns';

export default function TokenColumn({
  data,
  tokenStats,
  period,
}: ColumnsProps) {
  return (
    <span
      className={
        isTokenSuspiciousCheck(suspiciousCheckData(tokenStats, data))
          ? 'xxs:text-dex-white-secondary'
          : ''
      }
    >
      <div className="flex items-center xxs:gap-2">
        <TokenIconWithChain
          hasIcon={data.hasIcon}
          tokenName={data.base}
          chain={data.chain ?? Chains.Ethereum}
          protocol={data.dex}
          symbol={data.base}
          className="w-6 h-6"
          address={data.tokenAddress}
        />
        <div className="max-w-[120px] overflow-hidden truncate">
          <span>
            <span className="font-bold text-sm">{data.base}</span>/
            <span className="xxs:text-dex-white-secondary xxs:text-xs">
              {data.quote}
            </span>
          </span>
          <div>
            <EthAddress
              address={data.tokenAddress}
              precision={3}
              kind="token"
              className="text-xs"
              chain={data.chain ?? Chains.Ethereum}
            />
          </div>
        </div>
        <SuspiciousLabelAlert
          period={period}
          alertItems={isTokenSuspicious(suspiciousCheckData(tokenStats, data))}
        />
      </div>
    </span>
  );
}
